import { render, staticRenderFns } from "./goods-sku.vue?vue&type=template&id=cdc4cf1c&scoped=true&"
import script from "./goods-sku.vue?vue&type=script&lang=js&"
export * from "./goods-sku.vue?vue&type=script&lang=js&"
import style0 from "./goods-sku.vue?vue&type=style&index=0&id=cdc4cf1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc4cf1c",
  null
  
)

export default component.exports